export interface CreateReserveConditionRequest {
  branchCode: string
  userType: string
}

export function CreateReserveConditionRequestToJSON(
  value: CreateReserveConditionRequest
): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    user_type: value.userType !== '' ? value.userType : undefined
  }
}
